<button mat-icon-button class="toggle-btn" (click)="onToggleClick()">
  <mat-icon>menu</mat-icon>
</button>
<div class="sidenav">
  <div class="logo-box">
    <div class="logo" routerLink="/"></div>
  </div>
</div>

<mat-list class="list">
  <ng-container *ngFor="let menuItem of menus" class="menu-item">
    <ng-container *ngIf="isShowMenuItem(menuItem)">
      <mat-list-item
        class="menu-item"
        routerLink="{{menuItem.path}}" routerLinkActive="active" #rla="routerLinkActive">
        <div class="menu-item-content">
          <img class="sidenav-icon" [ngClass]="{'active-icon': rla.isActive}"
               [ngSrc]="getIconPath(menuItem)" width="24" height="24" alt="">
          <h3>{{ menuItem.label }}</h3>
        </div>
      </mat-list-item>
    </ng-container>
  </ng-container>
</mat-list>
